import type { BaseTranslation } from '../i18n-types';

export const profile = {
    title: 'Profile',
    metaTitle: 'Edit Profile',
    edit: 'Edit profile',
    changePassword: 'Change password',
    setPassword: {
        title: 'You don’t have a password yet',
        description:
            'Your account doesn’t have a password because you signed up via Google. To set your password, please use the password recovery form.',
        buttonLabel: 'Set password',
    },
    yourPasswordWasChanged: 'Your password was changed',
    deactivateAccount: 'Deactivate account',
    email: 'Email',
    yourEmail: 'Your email:',
    verificationResendText:
        'The verification link has been sent to your email. Please click on it for confirmation',
    verificationResendAllow: 'Resend the link',
    verificationResendDisabled: 'Resend the link in {time:string} min',
    verifyError: 'Verify your email',
    location: 'Location',
    country: 'Country:',
    yourCountry: 'Your country',
    state: 'State',
    city: 'City:',
    yourCity: 'Your city',
    street: 'Street',
    zip: 'ZIP-code',
    personalInformation: 'Personal information',
    nickname: 'Nickname:',
    yourNickname: 'Your nickname',
    languagesYouSpeak: 'Languages you speak ({count}):',
    automaticTranslation: 'Automatic translation:',
    translateMessagesAutomaticallyTo: 'Translate messages automatically to',
    interestsAndFetishes: 'Interests and fetishes ({count})',
    searchForInterests: 'Search for {interestsTotal} interests',
    saveChanges: 'Save changes',
    currentPassword: 'Current password',
    newPassword: 'New password',
    subscription: {
        title: 'Subscription',
        metaTitle: 'Subscriptions and Minutes',
        empty: {
            title: 'Уou don\'t have an active subscription',
            subtitle: 'Buy membership to get minutes and chat with girls',
        },
        balance: {
            title: 'Minutes Balance',
            subscribeMinutesLeft: 'Subscribe minutes left',
            extraMinutesLeft: 'Extra minutes left',
            buyExtraMinutes: 'Buy extra minutes',
            min: 'min',
        },
        details: {
            title: 'Subscription details',
            status: 'Status',
            active: 'Active',
            cancelled: 'Cancelled',
            paymentExpected: 'Payment expected',
            package: 'Package',
            payment: 'Payment',
            nextBillingDate: 'Next billing date',
            expires: 'Expires on',
            autoRenew: 'Auto-renewal',
        },
        unsubscribe: 'Unsubscribe',
        unsubscribeInfo: 'If you unsubscribe now you can still use your subscription until',
        unsubscribeDialog: {
            title: 'Are you sure you want to cancel your subscription?',
            subtitle:
                'After canceling the subscription, regular charges will no longer be applied to your account. Your current subscription will be active until {date:string}.',
            cancel: 'Keep it on',
            ok: 'Cancel subscription',
            success: 'Your subscription has been cancelled',
        },
    },
    delete: {
        title: 'We\'re sorry to hear you want to deactivate your account',
        needCancelSubscription:
            'Please cancel your subscription before deactivating or deleting your account',
        waitRebillSubscription:
            'Account deletion is not possible if your subscription ended within the past 3 days. Please cancel your subscription or wait at least 3 days before trying again.',
        radioDeactivate: {
            label: 'Deactivate account',
            description: `Choose if you just want to stop using {appName:string} for some time`,
        },
        radioDelete: {
            label: 'Delete account',
            description: {
                main: 'All your account data will be deleted',
                warning: 'without the possibility to restore',
            },
        },
        deactivateBtn: 'Deactivate account',
        deleteBtn: 'Delete account',
        reasonPlaceholder: 'Choose the reason',
        reasonLabel: 'Please tell us the reason:',
        reasons: {
            haveAnotherAccount: 'I have another account',
            tooExpensive: 'Too expensive',
            notEarningEnough: 'I\'m not earning enough',
            notEnoughPeople: 'Not enough people to chat with',
            worriedAboutPrivacy: 'I\'m worried about my privacy and data security',
            noLongerInterested: 'No longer interested',
            receivedInsultsOrThreats: 'I received insults/threats and I\'m worried about my safety',
            other: 'Other',
        },
        dialogDelete: {
            title: 'Are you sure you want to delete your account for good?',
            description: {
                main: 'All your account data will be deleted',
                warning: 'without the possibility to restore',
            },
            btnCancel: 'Cancel',
            btnSuccess: 'Delete account',
        },
        dialogDeactivate: {
            title: 'Are you sure you want to deactivate your account?',
            description: 'You can restore it at any time through our support service',
            btnCancel: 'Cancel',
            btnSuccess: 'Deactivate account',
        },
        passwordLabel: 'Your password:',
    },
    successUpdate: 'Data has been updated',
} satisfies BaseTranslation;
